<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard">
    <!-- Forma 1 -->
    <div v-show="hasPermission(['IU EHS VIEW'])">
      <vs-row>
        <vs-col vs-lg="8" vs-sm="12" class="mb-3 px-1">
          <vx-card :title="$t('EHS')+' - '+$t('status_compliance_details')" :style="{height:tableHeight+'vh',overflow:'auto'}" >
          <table-striped :tableHeight="tableHeight" :users="permitListTable"></table-striped>
          </vx-card>
        </vs-col>
        <vs-col  vs-lg="4" vs-sm="12" >
          <vx-card :title="$t('status_compliance')" :style="{height:tableHeight+'vh'}" class="px-1">
            <div slot="no-body" id="loading-donut">
              <vue-apex-charts
                class="mt-6 mb-8"
                type="donut"
                height="325"
                :options="chartOptions"
                :series="series"
                id="mychart"
                @dataPointSelection="RenderTable"
              />
            </div>
          </vx-card>
        </vs-col>
      </vs-row>

      <vs-row class="my-2">
        <vx-card>
          <div class="con-tablex vs-table--content">
            <div class="vs-con-tbody vs-table--tbody" id="loading-table-2">
              <div id="overflowMatrix">
                <table class="vs-table vs-table--tbody-table matrix-table">
                  <thead>
                    <tr class="tr-values vs-table--tr tr-table-state-null">
                      <th id="document-name" class="vs-table-text p">{{$t('ehs_catalog')}}</th>
                      <template v-for="(client) in clients">
                        <th
                          class="vs-table-text minimun-width text-center"
                          :title="client.name"
                          :key="client.id"
                        >{{client.code}}</th>
                      </template>
                    </tr>
                  </thead>

                  <tbody>
                    <template v-for="(catalog, index) in matrix">
                      <tr class="tr-body tr-values vs-table--tr tr-table-state-null" :key="index">
                        <!-- class="zui-sticky-col" -->
                        <template v-for="(column, index2) in catalog">
                          <td class="td vs-table--td" style="content-align: center" :key="index2">
                            <template v-if="index2 == 0">
                              <!-- :class="{'light-gray': isEven($index) === true }"-->
                              <div>{{column}}</div>
                            </template>
                            <template v-else-if="column == 0">
                              <span style="color:lightgray;">-</span>
                            </template>
                            <template v-else>
                              <template v-for="(ehs, i_ehs) in column">
                                <span-custom
                                  :icon="ehs[0]"
                                  :color="ehs[1]"
                                  :status="ehs[3]"
                                  :building="ehs[4]"
                                  :ehs_name="ehs[2]"
                                  :key="i_ehs"
                                />
                              </template>
                            </template>
                          </td>
                        </template>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </vs-row>
    </div>
  </div>
</template>

<script>
import TableStriped from './pages/home/tables/TableStriped.vue'
import EhsDashboardTable from '@/views/apps/ehs/EhsDashboardTable.vue'
import VueApexCharts from 'vue-apexcharts'
import CustomSpanDasboard from '@/views/components/CustomSpanDasboard.vue'
import ChartjsComponentDoughnutChart from './pages/home/charts/ChartjsComponentDoughnutChart.vue'

import dashboard from '@/http/requests/ehs'

export default {
  components: {
    TableStriped,
    VueApexCharts,
    ChartjsComponentDoughnutChart,
    'span-custom': CustomSpanDasboard,
    EhsDashboardTable
  },
  data() {
    return {
      series: [1],
      tableHeight:60,
      chartOptions: {
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: false,
                  label: this.$i18n.messages[this.$i18n.locale].on_time,
                  formatter: function (w) {
                    let total = 0; let number; let numberOut = 0;
                    w.globals.seriesTotals.forEach(element => {
                      total = total + parseInt(element)
                    })
                    let indice = w.globals.seriesNames.indexOf('Not in Compliance')

                    number = total - parseInt(w.globals.seriesTotals[indice])
                    if (number != NaN) {
                      numberOut = Math.round(number * 100 / total)
                    }
                    if (indice == -1) (
                      numberOut = 100
                    )
                    return numberOut + '%'
                  }
                },
                name: {
                  show: true,
                  fontSize: '22px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 600,
                  color: '#457503',
                  offsetY: -10
                },
                value: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'Helvetica, Arial, sans-serif',
                  fontWeight: 400,
                  color: undefined,
                  offsetY: 16,
                  formatter(val, w, label) {
                    let total = 0
                    w.globals.seriesTotals.forEach(element => {
                      total = total + parseInt(element)
                    })
                    return val
                    //return Math.round(val*100/total,-1) + ' %'
                  }
                }
              }
            }
          }
        },
        chart: {
          id: 'mychart'
        },
        tooltip: {
          enabled: false
        },
        legend: {
          position: 'bottom',
          markers: {
            fillColors: ['#E5E5E5']
          }
        },
        fill: {
          colors: ['#E5E5E5']
        },
        labels: ['Label'],
        dataLabels: {
          enabled: false
        }
      },
      colors: [],
      labelsDonut: [],
      permitList: [],
      permitListTable: [],
      //variables matriz en javascript
      matrix: [],
      clients: [],
      catalog: [],
      infoMatrix: []
    }
  },
  beforeMount() {
    this.$store.dispatch('clearGlobalEhsFilter')
  },
  mounted() {
    this.init()
    this.openLoadingDonut()
    this.openLoadingTable1()
    this.openLoadingTable2()
  },
  methods: {
    RenderTable(event, chartContext, config) {
      this.permitListTable = this.filterByState(this.permitList, this.labelsDonut[config.dataPointIndex])
    },
    init() {
      dashboard.ehsTableList()
        .then(res => {
          this.permitList = res.data.permissions
          this.fillChartData(this.permitList)
          this.permitListTable = this.filterByState(this.permitList, 'Not in Compliance')
          if (this.permitListTable.length == 0) {
            this.permitListTable = this.filterByState(this.permitList, 'In Compliance')
          }
        })
        .catch(err => {
          console.log(err)
        })
      dashboard.ehsTableMatrix()
        .then(res => {
          this.clients = res.data.clients
          this.catalog = res.data.catalogs
          this.infoMatrix = res.data.info
          this.sortMatrix(this.clients, this.catalog)
        })
        .catch(err => {
          console.log(err)
        })
    },
    countByState(data, state) {
      let count = 0
      data.forEach(element => {
        if (element.status_name == state) {
          count++
        }
      })
      return count
    },
    filterByState(data, state) {
      const filteredData = []
      data.forEach(element => {
        if (element.status_name == state) {
          filteredData[filteredData.length] = element
        }
      })
      return filteredData
    },
    fillChartData(dataToChart) {
      const dataValues = []
      const states = []
      dataToChart.forEach(element => {
        if (states.indexOf(element.status_name) === -1) {
          states[states.length] = element.status_name
          this.colors[this.colors.length] = element.status_color==null ? '#E8ECE9': element.status_color //Si no hay color en DB poner Gris Default
        }
      })

      states.forEach(element => {
        dataValues[dataValues.length] = this.countByState(dataToChart, element)
      })

      this.series = dataValues
      this.labelsDonut = states
      ApexCharts.exec('mychart', 'updateOptions', {
        fill: {
          colors: this.colors
        },
        legend: {
          markers: {
            fillColors: this.colors
          }
        },
        labels: this.labelsDonut
      }, false, true);
      this.closeLoadingDonut()
    },
    sortMatrix(clients, catalog) {
      let aux = []
      const auxMatrix = []
      const idsCatalog = []
      const idsClient = []
      //zero full matrix
      for (let i = 0; i < catalog.length; i++) {
        auxMatrix[i] = []
        idsCatalog[i] = catalog[i].id
        for (let j = 0; j < clients.length; j++) {
          auxMatrix[i][j] = 0
          if (i == 0) {
            idsClient[j] = clients[j].id
          }
        }
      }
      this.infoMatrix.forEach((element, index) => {
        if (auxMatrix[idsCatalog.indexOf(element.catalog_id)][idsClient.indexOf(element.client_id)] == 0) {
          aux[0] = [
            element.icon,
            element.status_color,
            element.ehs_name,
            element.status,
            element.building_number
          ]
        } else {
          aux = auxMatrix[idsCatalog.indexOf(element.catalog_id)][idsClient.indexOf(element.client_id)]
          aux.push([
            element.icon,
            element.status_color,
            element.ehs_name,
            element.status,
            element.building_number
          ])
        }
        auxMatrix[idsCatalog.indexOf(element.catalog_id)][idsClient.indexOf(element.client_id)] = aux
        aux = []
      })

      catalog.forEach((cat, index) => {
        auxMatrix[index].unshift(cat.name)
      })
      this.matrix = auxMatrix
      this.closeLoadingTable2()
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1
      })
      setTimeout(() => {
        this.$vs.loading.close('#div-with-loading > .con-vs-loading')
      }, 3000);
    },
    openLoadingDonut() {
      this.$vs.loading({
        container: '#loading-donut',
        scale: 0.6
      })
    },
    openLoadingTable1() {
      this.$vs.loading({
        container: '#loading-table-1',
        scale: 0.6
      })
    },
    openLoadingTable2() {
      this.$vs.loading({
        container: '#loading-table-2',
        scale: 0.6
      })
    },
    closeLoadingDonut() {
      this.$vs.loading.close('#loading-donut > .con-vs-loading')
      this.$vs.loading.close('#loading-table-1 > .con-vs-loading')
    },
    closeLoadingTable2() {
      this.$vs.loading.close('#loading-table-2 > .con-vs-loading')
    }
  },
  computed: {
    allowed_to_see_module(){
      let allowed = localStorage.getItem('permissions').includes('IU EHS VIEW')
      return allowed
    }
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#document-name {
  width: 200px;
}
.matrix-table {
  table-layout: fixed;
  width: 100%;
  font-size: 0.8rem;
}
.matrix-table th {
  width: 5rem;
}
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
.sm {
  font-size: 1rem;
}

.color-gray {
  color: rgba(131, 131, 131, 0.589);
}

#overflowMatrix {
  overflow: scroll;
  height: 80vh;
}

th {
  background: white;
  position: sticky;
  top: 0;
  z-index: 3000;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
  z-index: 2;
}

td:first-child {
  text-align: left;
}
td {
  text-align: center;
}

/* ToolTip CSS */
.tooltip {
  position: relative;
  display: inline-block;
}
.tooltip .tiptext {
  visibility: hidden;
  width: 120px;
  background-color: rgba(186, 19, 0, 0.815);
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 6px 0;
  position: absolute;
  z-index: 4001;
}
.tooltip .tiptext::after {
  content: "";
  position: absolute;
  border-width: 5px;
  border-style: solid;
}
.tooltip:hover .tiptext {
  visibility: visible;
}
/* ToolTip Left */
.tooltip.left .tiptext {
  top: -1rem;
  right: 110%;
}
.tooltip.left .tiptext::after {
  margin-top: -5px;
  top: 50%;
  left: 100%;
  border-color: transparent transparent transparent rgba(186, 19, 0, 0.815);
}
/* Tootip Top */
.tooltip.top .tiptext {
  margin-left: -60px;
  bottom: 150%;
  left: 50%;
}
.tooltip.top .tiptext::after {
  margin-left: -5px;
  top: 100%;
  left: 50%;
  border-color: transparent transparent transparent rgba(186, 19, 0, 0.815);
}

.tr-body .vs-table--td:first-child {
  position: sticky;
  left: 0;
  background: #fff;
  border-right: 1px solid #ccc;
  z-index: 4000;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none !important;
  transform: none !important;
}

</style>
